export default __webpack_public_path__ + "static/media/RubyNguyen.81dd24e8.png";